<script lang="ts">
  import type { OpenProductGroup } from "@shared/types/OpenProductGroup";
  import LayoutStore from "@shared/svelte/Stores/LayoutStore";
  import ProductImage from "@shared/svelte/Components/ProductImage.svelte";
  import { EventTracking } from "@shared/services/event_tracking/events";
  import { OpenProductGroupCardEntity } from "@shared/services/event_tracking/entities";

  export let openProductGroups: OpenProductGroup[] = [];

  const imageHeight = 72;
  const imageWidth = 72;

  const { trackClick } = EventTracking;
</script>

<style lang="scss">
  .full-width-mobile-only {
    @media (max-width: 425px) {
      width: 100%;
    }
  }
</style>

<div class="fizz-expand-32-on-large fizz-expand-16-on-small fizz-inset-horizontal-32">
  {#each openProductGroups as group}
    <div class="fizz-card fizz-card-interactive fizz-bordered fizz-stack-16 fizz-inset-square-24">
      <div
        class="fizz-flex-row-responsive fizz-space-between"
        class:justify-center={$LayoutStore.isMobile}
      >
        <figure class="fizz-flex-row-0" class:justify-center={$LayoutStore.isMobile}>
          <div class="fizz-flex-no-shrink images" data-testid="product-group-image">
            <ProductImage
              product={{ cloudinary_image_url: group.product_image }}
              height={imageHeight}
              width={imageWidth}
              fizz={true}
            />
          </div>
          <div class="fizz-text-left">
            <p class="fizz-text-large fizz-text-strong">{group.name}</p>
            <p class="fizz-text-subdued">All products available</p>
          </div>
        </figure>
        <div class="fizz-inset-horizontal-16 full-width-mobile-only">
          <a
            href={`/product_listing?type=${group.product_type_id}`}
            on:click={() => {
              trackClick("open_product_group_card", [new OpenProductGroupCardEntity(group)]);
            }}
            data-testid="open-product-group-card-button"
          >
            <button class="fizz-button full-width-mobile-only">Shop product group</button>
          </a>
        </div>
      </div>
    </div>
  {/each}
</div>
